import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import NavBar from './NavBar';
import SettingsNav from './SettingsNav';

const UserSettingsLayout = ({ children }) => {
  return (
    <Flex direction="column" bg="#f0f0f0" minH="100vh">
      <NavBar />
      <Flex justify="center" pt={4} pb={8} flex="1" px={{ base: 3, md: 0 }}>
        <Box
          width={{ base: '100%', md: '90%' }}
          maxW="1100px"
          borderRadius="16px"
          overflow="hidden"
          bg="white"
        >
          <Flex direction={{ base: 'column', md: 'row' }} minH="600px">
            <SettingsNav />
            <Box flex="1" minW="0">
              {children}
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};

export default UserSettingsLayout;
